import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from '../../../Axios'


const Committee = () => {
  const [activeCommittee, setActiveCommittee] = useState("Anti Ragging Committee");
  const [formData, setFormData] = useState({
    committeeId: "673b33bb219d24599c065916", // Default to Anti Ragging Committee ID
    newMember: {
      name: "",
      designation: "",
      department: "",
      email: "",
      number: "",
    },
  });
  const [loading, setLoading] = useState(false);

  const committees = [
    { title: "Anti Ragging Committee", id: "673b33bb219d24599c065916" },
    { title: "Online Grievance Redressal Committee / ICC", id: "673b3405219d24599c06591c" },
  ];

  const handleCommitteeChange = (committee) => {
    console.log("Selected committee:", committee.title);
    setActiveCommittee(committee.title);
    setFormData({
      committeeId: committee.id,
      newMember: {
        name: "",
        designation: "",
        department: "",
        email: "",
        number: "",
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Form Data on Submit:", formData);

    const { committeeId, newMember } = formData;

    if (!committeeId || !newMember.name || !newMember.designation || !newMember.department || !newMember.email || !newMember.number) {
      toast.error("All fields are required.");
      setLoading(false);
      return;
    }

    try {
      const response = await api.post(`${process.env.REACT_APP_BASE_URL}/api/v1/committees/add-staff`, { committeeId, newMember });
      toast.success(`${activeCommittee} member added successfully!`);
      setFormData({
        committeeId: activeCommittee,
        newMember: { name: "", designation: "", department: "", email: "", number: "" },
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      newMember: { ...formData.newMember, [name]: value },
    });
  };

  return (
    <div className="container mx-auto p-4 sm:p-6 space-y-6 sm:space-y-8">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-center space-y-2 sm:space-y-0">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-center">Governance/Committee</h1>
      </div>

      <div className="mb-6 flex justify-center space-x-4">
        {committees.map((committee) => (
          <button
            key={committee.title}
            onClick={() => handleCommitteeChange(committee)}
            className={`py-2 px-4 rounded-lg text-lg font-semibold ${activeCommittee === committee.title ? "bg-teal-500 text-white" : "bg-transparent text-teal-500 hover:bg-teal-100"}`}
          >
            {committee.title}
          </button>
        ))}
      </div>

      <motion.div
        className="bg-white shadow-xl rounded-lg p-8 w-full max-w-3xl mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-3xl font-semibold text-white text-center py-4 mb-8 rounded-t-lg" style={{ backgroundColor: "#00BFA5" }}>
          {activeCommittee}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="name" className="block text-gray-600 text-sm font-medium mb-2">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.newMember.name}
              onChange={handleChange}
              placeholder="Enter Name"
              required
              className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
            />
          </div>
          <div className="mb-6">
            <label htmlFor="designation" className="block text-gray-600 text-sm font-medium mb-2">Designation</label>
            <input
              type="text"
              id="designation"
              name="designation"
              value={formData.newMember.designation}
              onChange={handleChange}
              placeholder="Enter Designation"
              required
              className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
            />
          </div>
          <div className="mb-6">
            <label htmlFor="department" className="block text-gray-600 text-sm font-medium mb-2">Department</label>
            <input
              type="text"
              id="department"
              name="department"
              value={formData.newMember.department}
              onChange={handleChange}
              placeholder="Enter Department"
              required
              className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
            />
          </div>
          <div className="mb-6">
            <label htmlFor="email" className="block text-gray-600 text-sm font-medium mb-2">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.newMember.email}
              onChange={handleChange}
              placeholder="Enter Email"
              required
              className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
            />
          </div>
          <div className="mb-6">
            <label htmlFor="number" className="block text-gray-600 text-sm font-medium mb-2">Phone Number</label>
            <input
              type="tel"
              id="number"
              name="number"
              value={formData.newMember.number}
              onChange={handleChange}
              placeholder="Enter Phone Number"
              required
              className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
            />
          </div>

          <div className="flex justify-center mb-6">
            <button
              type="submit"
              className={`w-full py-3 text-white font-semibold rounded-lg ${loading ? "bg-teal-300 cursor-not-allowed" : "bg-teal-500 hover:bg-teal-600"}`}
              disabled={loading}
            >
              {loading ? "Adding..." : "Add Member"}
            </button>
          </div>
        </form>
      </motion.div>
      <ToastContainer />
    </div>
  );
};

export default Committee;
